import { lazy } from 'react';
import { getMainPageTitleId } from './pages/my-opensooq/helpers';

const MainLayout = lazy(() => import('../../layouts/main-layout/MainLayout'));
const MyOpenSooqPage = lazy(() => import('./pages/my-opensooq/MyOpenSooqPage'));
const InventoryPage = lazy(() => import('./pages/inventory/InventoryPage'));
const ProductsPage = lazy(() => import('./pages/products/ProductsPage'));
const RequestFeaturePage = lazy(() => import('./pages/request-feature/RequestFeaturePage'));
const InviteFriendsPage = lazy(() => import('./pages/invite-friends/InviteFriendsPage'));
const CarReportsPage = lazy(() => import('./pages/car-reports/CarReportsPage'));
const CarfaxReportsPage = lazy(() => import('./pages/car-reports/CarfaxReportsPage'));
const CarseerReportsPage = lazy(() => import('./pages/car-reports/CarseerReportsPage'));
const CarReportDetailsPage = lazy(() => import('./pages/car-reports/CarReportDetailsPage'));
const myOpenSooqHandle = { title: getMainPageTitleId() };
const ChatScreen = lazy(() => import('app/modules/socket-v5/App'));
const ChatOpen = lazy(() => import('app/modules/socket-v5/pages/ChatOpen'));
const NotificationPage = lazy(() => import('./pages/notification/NotificationPage'));

const dashboardRoutes = [
  {
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <MyOpenSooqPage />,
        handle: myOpenSooqHandle,
      },
      {
        path: '/index.html',
        element: <MyOpenSooqPage />,
        handle: myOpenSooqHandle,
      },
      {
        path: '/auth/*',
        element: <MyOpenSooqPage />,
        handle: myOpenSooqHandle,
      },
      {
        path: '/inventory',
        element: <InventoryPage />,
        handle: {
          title: 'routes.inventory',
        },
      },
      {
        path: '/request-feature',
        element: <RequestFeaturePage />,
        handle: {
          title: 'routes.requestFeature',
        },
      },
      {
        path: '/invite-friends',
        element: <InviteFriendsPage />,
        handle: {
          title: 'routes.inviteFriend',
        },
      },
      {
        path: '/products',
        element: <ProductsPage />,
        handle: {
          title: 'routes.products',
        },
      },
      {
        path: '/services/car-reports',
        element: <CarReportsPage />,
        handle: {
          title: 'routes.carReports',
        },
      },
      {
        path: '/services/carfax-report',
        element: <CarfaxReportsPage />,
        handle: {
          title: 'routes.carfaxReports',
        },
      },
      {
        path: '/services/carseer-report',
        element: <CarseerReportsPage />,
        handle: {
          title: 'routes.carseerReports',
        },
      },
      {
        path: '/services/car-reports/carReportDetails/:id/:type',
        element: <CarReportDetailsPage />,
        handle: {
          title: 'routes.carReports',
        },
      },
      {
        path: '/chats',
        element: <ChatScreen />,
        handle: {
          title: 'routes.chats',
        },
      },
      {
        path: '/notifications',
        element: <NotificationPage />,
        handle: {
          title: 'routes.notifications',
        },
      },
    ],
  },
  {
    path: '/chats/open/:postId/:sellerId/:buyerId',
    element: <ChatOpen />,
    handle: {
      title: 'routes.chats',
    },
  },
  {
    path: '/chats/open',
    element: <ChatOpen />,
    handle: {
      title: 'routes.chats',
    },
  },
];

export default dashboardRoutes;
